/* Submits exactly once through Shopify's existing product-form handler, using the selected variant and quantity. */
(() => {
  if (window.ot22StickyReady) return;
  window.ot22StickyReady = true;
  let observer, mutation, form, mainButton, bar, trigger;
  const visible = () => {
    if (!mainButton || !bar) return;
    const rect = mainButton.getBoundingClientRect();
    bar.classList.toggle('is-visible', rect.bottom < 0);
  };
  const sync = () => {
    if (!bar || !mainButton) return;
    const busy = mainButton.classList.contains('loading');
    const variantId = form.querySelector('[name="id"]')?.value;
    const disabled = mainButton.disabled || busy || mainButton.getAttribute('aria-disabled') === 'true' || !variantId;
    const info = form.closest('product-info');
    let variant = null;
    try { variant = JSON.parse(info?.querySelector('variant-selects [data-selected-variant]')?.textContent || 'null'); } catch (_) { /* Native form still controls availability. */ }
    const error = info?.querySelector('.product-form__error-message-wrapper:not([hidden]) .product-form__error-message')?.textContent?.trim();
    trigger.disabled = disabled;
    trigger.textContent = busy ? 'Añadiendo…' : error ? 'Revisar selección' : disabled ? (variant && !variant.available ? trigger.dataset.unavailableLabel || 'Agotado' : variantId ? 'Actualizando opción…' : 'No disponible') : trigger.dataset.availableLabel || 'Añadir al carrito';
    trigger.setAttribute('aria-busy', busy ? 'true' : 'false');
    const price = info?.querySelector('[data-ot-current-price]');
    const priceTarget = bar.querySelector('[data-ot-sticky-price]');
    if (priceTarget) {
      const visiblePrice = Boolean(variantId && price && !price.closest('.hidden,[hidden]'));
      priceTarget.hidden = !visiblePrice;
      if (visiblePrice) priceTarget.textContent = price.textContent.trim();
    }
    visible();
  };
  function init() {
    const nextBar = document.querySelector('[data-ot22-sticky]');
    const info = document.querySelector('#MainContent product-info');
    const nextForm = info?.querySelector('product-form form');
    const nextMain = nextForm?.querySelector('.product-form__submit');
    if (!nextBar || !nextForm || !nextMain) return;
    if (nextBar === bar && nextForm === form && nextMain === mainButton) return sync();
    observer?.disconnect(); mutation?.disconnect();
    bar = nextBar; form = nextForm; mainButton = nextMain; trigger = bar.querySelector('[data-ot-sticky-btn]');
    bar.hidden = false;
    if (!trigger.dataset.bound) {
      trigger.dataset.bound = 'true';
      trigger.addEventListener('click', () => {
        sync();
        if (trigger.disabled || mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true') return;
        if (typeof form.reportValidity === 'function' && !form.reportValidity()) {
          mainButton.scrollIntoView({ behavior: 'auto', block: 'center' }); return;
        }
        if (typeof form.requestSubmit === 'function') form.requestSubmit(mainButton);
        else mainButton.click();
        sync();
      });
    }
    if ('IntersectionObserver' in window) { observer = new IntersectionObserver(visible); observer.observe(mainButton); }
    else window.addEventListener('scroll', visible, { passive: true });
    mutation = new MutationObserver(sync);
    mutation.observe(mainButton, { attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] });
    sync();
  }
  document.addEventListener('variant:change', sync);
  document.addEventListener('ot:pdp-state', sync);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();
